import { Flex, Td, Text, Tr } from '@chakra-ui/react';
import { formatCurrency, formatName } from '@/utils';
import React, { useEffect, useState } from 'react';
import s from './styles.module.scss';
import { useDispatch } from 'react-redux';
import { closeModal, openModal } from '@/state/modal';
import cx from 'clsx';
import { PROPOSAL_MODAL_NAME } from '@/modules/AlphaPWA/DirectMessage/Chat/Proposal/constants';
import VotingModal from '@/modules/AlphaPWA/DirectMessage/Chat/Proposal/VotingModal';
import useWindowSize from '@/hooks/useWindowSize';
import moment from 'moment';
import { useMemo } from 'react';
import CAlphaGovernor from '@/contracts/alphaGovernor';
import { formatEther } from 'ethers/lib/utils';
import { labelAmountOrNumberAdds } from '@/modules/AlphaPWA/Profiles/TradeKey/constants';

interface LabelStatusMap {
  [name: string]: any;
}

const ProposalStatus: LabelStatusMap = {
  new: 'Active',
  excuted: 'Executed',
  defeated: 'Defeated',
  cancel: 'Canceled',
  end: 'Ended',
};

const BlastItem = ({ data, profile, onClick }: any) => {
  const dispatch = useDispatch();
  const { mobileScreen } = useWindowSize();
  const governorContract = new CAlphaGovernor();

  const [proposalData, setProposalData] = useState<any>(null);

  const isEndProposal = useMemo(() => {
    return (
      data &&
      data.vote_end_at &&
      data.status === 'new' &&
      moment().isAfter(moment(data?.vote_end_at))
    );
  }, [data]);

  useEffect(() => {
    if (data) {
      fetchTreasury();
    }
  }, [data]);

  const fetchTreasury = async () => {
    try {
      const res = await governorContract.getCreateProposalData(
        data.targets ? JSON.parse(data.targets)[0] : '',
        data.calldatas ? JSON.parse(data.calldatas)[0] : ''
      );
      setProposalData(res);
    } catch (error) {}
  };

  const showListUserBlast = (e: any) => {
    e?.preventDefault();
    e?.stopPropagation();

    const close = () => dispatch(closeModal({ id: PROPOSAL_MODAL_NAME }));
    dispatch(
      openModal({
        id: PROPOSAL_MODAL_NAME,
        theme: 'dark',
        className: s.modalContentVoting,
        modalProps: {
          centered: false,
          zIndex: 9999999,
          size: mobileScreen ? 'full' : 'xxl',
        },
        hideCloseButton: true,
        render: () => (
          <VotingModal profile={profile} proposal={data} onClose={close} />
        ),
      })
    );
  };

  const status = data?.status === 'new' && isEndProposal ? 'end' : data?.status;

  const getTitle = () => {
    try {
      if (data || data.description) {
        const _data = JSON.parse(data.description as string);
        return _data.title;
      }
    } catch (error) {
      return data?.description || '';
    }
  };

  return (
    <Tr className={s.container} onClick={showListUserBlast}>
      <Td>
        <Text
          fontSize={'14px'}
          color={'#FFFFFF !important'}
          fontWeight={'500'}
          opacity={'70%'}
        >
          {data?.id || ''}
        </Text>
      </Td>
      <Td>
        <Flex direction="column">
          <Text className={s.buyer}>
            {formatName(getTitle() as string, 150)}
          </Text>
          {proposalData && (
            <>
              <Text color="gray !important" mt="2px" fontSize="12px">
                Amount:{' '}
                {formatCurrency(formatEther(proposalData[1]), 0, 0, 'TC', true)}
              </Text>
            </>
          )}
        </Flex>
      </Td>
      <Td>
        <Flex gap={2} direction={'column'} alignItems={'flex-end'} flex={1}>
          <Text className={cx(s.status, s[status])}>
            {ProposalStatus[status as string]}
          </Text>
        </Flex>
      </Td>
    </Tr>
  );
};

export default BlastItem;
